import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ErrorMsgHandler } from '../shared/errormanagement/handleerror';
import { SharedService } from '../services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class ExplorelogsService {

  constructor(
    public sharedService: SharedService
  ) {
    this.sharedService.$userLoggedoff.subscribe(() => {
      this.explorelogIndex = 0;
    })
    this.sharedService.customerChanged_.subscribe(() => {
      this.explorelogIndex = 0;
    })
  }

  explorelogIndex: number = 0;

}
